import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserStore } from '@/store/userSlice';
import { apiFetch } from '@/lib/api';
import type { User } from '@/store/userSlice';

interface LoginResponse {
  user: User;
  access_token: string;
}

export function useLoginPage() {
  const navigate = useNavigate();
  const setAuth = useUserStore((s) => s.setAuth);
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const res = await apiFetch('/api/v1/auth/login', {
        method: 'POST',
        body: JSON.stringify({ login, password }),
      });

      if (res.status === 401) {
        setError('Неверный логин или пароль');
        return;
      }
      if (!res.ok) {
        const data = (await res.json().catch(() => null)) as { error?: string } | null;
        setError(data?.error ?? 'Не удалось войти. Попробуйте позже.');
        return;
      }

      const data = (await res.json()) as LoginResponse;

      // Воркер работает в мобильном приложении — сессию в CMS не сохраняем
      if (data.user.role === 'worker') {
        setError('Войдите в мобильное приложение');
        return;
      }

      setAuth(data.access_token, data.user);
      // Клиент без заполненной карточки организации — на форму данных
      // (гейт до первого сохранения); остальные — на дашборд
      const target =
        data.user.role === 'client' && !data.user.confirmed ? '/profile' : '/dashboard';
      navigate(target, { replace: true });
    } catch {
      setError('Ошибка сети. Проверьте подключение.');
    } finally {
      setLoading(false);
    }
  };

  return { login, setLogin, password, setPassword, loading, error, handleSubmit };
}
